import { Badge, styled } from '@ori-ui/mui';
import useTestId from '@ori/testid-generator';
import type { FC, PropsWithChildren, ReactElement } from 'react';
import { memo } from 'react';

import { LiveStreamingStateWrapTestIds, LiveStreamingStates } from '../../../models';

const NowLiveStreamingRoot = styled('div')(({ theme }) => ({
  borderRadius: 999,
  boxShadow: `0px 0px 0 2px ${theme.palette.red[300]}`,
  position: 'relative',
}));

const NowLiveStreamingText = styled('div')(({ theme }) => ({
  backgroundColor: theme.palette.red[300],
  fontSize: theme.typography.pxToRem(5),
  color: theme.palette.common.white,
  padding: theme.spacing(0, 0.8),
  borderRadius: '3px',
  position: 'absolute',
  left: '50%',
  transform: 'translateX(-50%)',
  bottom: theme.spacing(-1),
}));

const badgeSize = 2;
const StyledBadge = styled(Badge)(({ theme }) => ({
  '& .MuiBadge-badge': {
    backgroundColor: theme.palette.red[300],
    color: theme.palette.red[300],
    width: theme.spacing(badgeSize),
    minWidth: theme.spacing(badgeSize),
    height: theme.spacing(badgeSize),
    padding: 0,
    border: 0,
    position: 'absolute',
    right: 0,
    top: 0,
    transform: 'scale(1) !important',
  },
}));

export const LiveStreamingStateWrap: FC<PropsWithChildren & { streamingActivity: LiveStreamingStates }> = memo(
  ({ children, streamingActivity }) => {
    const { getTestIdProps } = useTestId();

    if (streamingActivity === LiveStreamingStates.WAS_LIVE || streamingActivity === LiveStreamingStates.PLANNED) {
      return (
        <StyledBadge {...getTestIdProps(LiveStreamingStateWrapTestIds.AVATAR_BADGE_WAS_LIVE)}>{children}</StyledBadge>
      );
    }

    if (streamingActivity === LiveStreamingStates.IS_LIVE) {
      return (
        <NowLiveStreamingRoot {...getTestIdProps(LiveStreamingStateWrapTestIds.AVATAR_BADGE_IS_LIVE)}>
          {children}
          <NowLiveStreamingText>LIVE</NowLiveStreamingText>
        </NowLiveStreamingRoot>
      );
    }

    return children as ReactElement;
  },
);
